import React, { Component } from 'react'
import { Icon } from 'meinian-package/src/component'
import { Tooltip } from 'antd'
import './index.less'

export default class FloatNav extends Component {
  static defaultProps = {
    scrollEleSelector: 'body',
    className: '',
    icon: 'm-zhiding',
    tooltip: false,
    root: false
  }

  state = {
    showToTop: false,
  }

  componentDidMount() {
    const scrollElement = this.props.root ? document : document.querySelector(this.props.scrollEleSelector)
    scrollElement.addEventListener('scroll', this.onShowToTop, true)
  }

  componentWillUnmount() {
    this.props.root && document.removeEventListener('scroll', this.onShowToTop, true)
    document.querySelector(this.props.scrollEleSelector).removeEventListener('scroll', this.onShowToTop, true)
  }

  onShowToTop = (e) => {
    const { scrollTop } = e.target
    if (this.props.root && e.target !== document) { return }
    if (e.target !== document.querySelector(this.props.scrollEleSelector)) { return }
    this.target = e.target
    this.setState({ showToTop: scrollTop >= 600 })
  }

  backTop = () => {
    if (this.target) this.target.scrollTop = 0
    window.scrollToTop()
  }

  render() {
    const { icon, className, style, tooltip } = this.props
    const { showToTop } = this.state
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>
      {
      showToTop && <div className={`float-nav-wrap ${className}`} style={style}>
        {tooltip ? <Tooltip placement="left" title="返回顶部">
          <span onClick={this.backTop} className={`float-nav float-nav-to-top ${showToTop ? 'active' : ''}`}>
            <Icon type={icon} />
          </span>
        </Tooltip> : <span onClick={this.backTop} className={`float-nav float-nav-to-top ${showToTop ? 'active' : ''}`}>
          <Icon type={icon} />
        </span>}
      </div>
    }
    </>
  }
}
